<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',

  methods:{

  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.row-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.row-space-between{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.col {
  display: flex;
  flex-direction: column;
}
.col-left{
  align-items: flex-start;
}
.col-right{
  align-items: flex-end;
}
.big-title{
  font-size: 48px;
}
.title{
  font-size: 36px;
}
.content{
  font-size: 30px;
}
.small-content{
  font-size: 25px;
}
.xs-content{
  font-size: 20px;
}
.topic-color{
  color: #FF7669 ;
}
</style>
